import { ADD_TO_CART, REMOVE_FROM_CART } from "./actionType";

const intialState = {
  products: [
    {
      productName: "Asus Vivobook X515MA ",
      productId: 1,
      productPrice: 35500,
      Qty: 5,
    },
    {
      productName: "Dell E1916HV 18.5 Inch ",
      productId: 2,
      productPrice: 9300,
      Qty: 6,
    },
    {
      productName: "Canon Eos 4000D 18MP ",
      productId: 3,
      productPrice: 36500,
      Qty: 4,
    },
  ],
  cart: [],
};

const productsReducer = (state = intialState, action) => {
  switch (action.type) {
    case ADD_TO_CART:
      const addProduct = state.products.find(
        (item) => item.productId === action.payload
      );
      const addCartItem = state.cart.find(
        (item) => item.productId === action.payload
      );

      if (addCartItem) {
        return {
          ...state,
          products: state.products.map((item) => {
            if (item.productId === action.payload) {
              return {
                ...item,
                Qty: item.Qty - 1,
              };
            }
            return item;
          }),
          cart: state.cart.map((item) => {
            if (item.productId === action.payload) {
              return {
                ...item,
                Qty: item.Qty + 1,
              };
            }
            return item;
          }),
        };
      } else {
        return {
          ...state,
          products: state.products.map((item) => {
            if (item.productId === action.payload) {
              return {
                ...item,
                Qty: item.Qty - 1,
              };
            }
            return item;
          }),
          cart: [...state.cart, { ...addProduct, Qty: 1 }],
        };
      }
    case REMOVE_FROM_CART:
      const removeCartItem = state.cart.find(
        (item) => item.productId === action.payload
      );

      if (removeCartItem.Qty >= 2) {
        return {
          ...state,
          products: state.products.map((item) => {
            if (item.productId === action.payload) {
              return {
                ...item,
                Qty: item.Qty + 1,
              };
            }
            return item;
          }),
          cart: state.cart.map((item) => {
            if (item.productId === action.payload) {
              return {
                ...item,
                Qty: item.Qty - 1,
              };
            }
            return item;
          }),
        };
      } else {
        const newCartItems = state.cart.filter(
          (item) => item.productId !== action.payload
        );
        return {
          ...state,
          products: state.products.map((item) => {
            if (item.productId === action.payload) {
              return {
                ...item,
                Qty: item.Qty + 1,
              };
            }
            return item;
          }),
          cart: [...newCartItems],
        };
      }

    default:
      return state;
  }
};

export const getProducts = (state) => state.products;
export const getCart = (state) => state.cart;
export default productsReducer;
